export default __webpack_public_path__ + "static/media/lsbd.83a7a7a2.svg";